import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProjetoImpactoOrcamentario } from '../../../models/projeto-impacto-orcamentario.model';
import { ProjetoImpactoOrcamentarioService } from '../../../services/projeto-impacto-orcamentario.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-impacto-orcamentario-list',
  templateUrl: './impacto-orcamentario-list.component.html',
  styleUrls: ['./impacto-orcamentario-list.component.scss'],
})
export class ImpactoOrcamentarioListComponent
  extends BaseListComponent<ProjetoImpactoOrcamentario>
  implements OnInit, OnDestroy
{
  impactoList: ProjetoImpactoOrcamentario[];
  totais: any;
  @Input() idProjeto: any;
  @Input() permissoes: any;

  constructor(
    private myService: ProjetoImpactoOrcamentarioService,
    public activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    if (this.idProjeto) {
      this.initLoadDataTable();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.getListAll(this.idProjeto).subscribe((res) => {
        this.impactoList = res['list'];
        this.totais = res['totais'];
        this.loaded();
      })
    );
  }

  novo() {
    return ['impacto/adicionar'];
  }

  editar(id: number) {
    return ['/pre-projeto/projeto/custos/impacto', id];
  }
}
